import { useContext, useEffect, useState } from "react";
import { NotificationsV1Service } from "../../../common/services/api/api";
import { Loading } from "../../../common/components/loading/loading";
import { IModal, Modal } from "../../../common/components/modal/modal";
import PostView from "../../posts/postView/postView";
import Moment from "react-moment";
import Context from "../../../common/components/utils/context";
import { IPushNotification } from "../../../common/components/utils/toasty";
import { useNavigate } from "react-router-dom";

const ContactsNotifications = () => {
  const context = useContext(Context);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [notifications, setNotifications] = useState<IPushNotification[]>();
  const [modal, setModal] = useState<IModal>();

  const handleClick = async (data: IPushNotification) => {
    if (!data.isRead) {
      context.setNotificationCount(context.notificationCount - 1);
      const notificationsService = new NotificationsV1Service();
      var response = await notificationsService.update(data.id);
      const updatedNotification: IPushNotification = response.data;
      setNotifications((prev) =>
        prev?.map((n) =>
          n.id === updatedNotification.id ? updatedNotification : n
        )
      );
    }
    if (data.type === "FOUNDAT_NEW_CONTACT_REQUEST") {
      navigate("/contacts");
    }
    if (data.type === "FOUNDAT_NEW_POST") {
      setModal({
        show: true,
        component: <PostView postId={data.postId} modal={true} />,
      });
    }
  };

  const fetchPosts = async () => {
    try {
      setLoading(true);
      const notificationsService = new NotificationsV1Service();
      const response = await notificationsService.getAll();
      const mappedNotifications: IPushNotification[] = response.data.map(
        (item: any) => ({
          id: item.Id,
          message: item.Message,
          senderId: item.SenderId,
          type: item.Type,
          pictureUrl: item.PictureUrl,
          postId: item.PostId ?? undefined,
          createdAt: item.CreatedAt ? new Date(item.CreatedAt) : undefined,
          readAt: item.ReadAt ? new Date(item.ReadAt) : undefined,
          isRead: item.IsRead,
        })
      );
      setNotifications(mappedNotifications);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  return loading ? (
    <Loading />
  ) : notifications?.length ? (
    <div className="grid">
      {notifications?.reverse().map((notification, idx) => {
        return (
          <div
            key={idx}
            className="flex items-center border-b py-4 cursor-pointer hover:bg-gray-50"
            style={{
              backgroundColor: notification.isRead ? "white" : "#f0f8ff",
            }}
            onClick={() => handleClick(notification)}
          >
            <img
              src={notification.pictureUrl}
              alt="notification"
              className="h-14 w-14 mx-8 rounded-full border"
            />
            <div className="flex-1">
              {notification.isRead ? (
                <span className="text-gray-500 text-sm">
                  {notification.message}
                </span>
              ) : (
                <span className="text-sm font-semibold">
                  {notification.message}
                </span>
              )}
            </div>
            <Moment
              className="text-gray-400 text-sm mx-4 whitespace-nowrap"
              date={new Date(notification.createdAt + "Z")}
              fromNow
              local
            />
          </div>
        );
      })}
      <Modal show={modal?.show} component={modal?.component} />
    </div>
  ) : (
    <div className="h-96 text-center flex items-center justify-center text-gray-400">
      <p>No notifications yet. We'll update you when there's something new!</p>
    </div>
  );
};

export default ContactsNotifications;
